import { useEffect, useState } from "react";
import { useAccountContext } from "./useAccountContext";
import { useAuthContext } from "./useAuthContext";
import { useSettingsContext } from "./useSettingsContext";
import axios from 'axios';


export const useTimeSheets = () => {
    const { username, user, clientApi, dispatch: authDispatch } = useAuthContext();
    const [isLoading, setIsLoading] = useState(true);
    const { account } = useAccountContext();
    const { isWinAuth } = useSettingsContext();

    const axiosInstance = axios.create({
        baseURL: `${clientApi}`,
        headers: {
            'accepts': 'application/json',
            'Content-Type': 'application/json',
        },
    });

    axiosInstance.interceptors.request.use(request => {
        // console.log('Set Bearer Token')
        const accessToken = user.token;
        if (accessToken) {
            request.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return request;
    }, error => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(
        response => response, // Directly return successful responses.
        async error => {
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
                try {
                    if (!isWinAuth) {
                        // Make a request to your auth server to refresh the token.
                        const response = await axiosInstance.post(`${clientApi}api/auth/refresh`, user);
                        // Store the new access and refresh tokens.
                        authDispatch({ type: 'Refresh', payload: response.data, clientApi: clientApi, username: username });

                        // Update the authorization header with the new access token.
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    }
                    else {
                        const newToken = await acquireSilentToken();
                        let tmpUser = user;
                        tmpUser.token = newToken;
                        authDispatch({ type: 'REFRESH', payload: tmpUser, clientApi: clientApi, username: username });
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                    }
                    return axios(originalRequest); // Retry the original request with the new access token.
                } catch (refreshError) {
                    // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                    console.error('Token refresh failed:', refreshError);
                    authDispatch({ type: 'LOGOUT' });
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error); // For all other errors, return the error as is.
        }
    );

    const loadTeacherperiods = async (timesheetUI) => {
        try {
            setIsLoading(true)
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/periods`, {
                params: { username: account.username, sTimesheetUI: timesheetUI }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const getTimeSheets = async () => {
        let timesheets = [];
        setIsLoading(true)
        await axiosInstance.get(`${clientApi}api/teachersperiods/timesheets`, {
            params: { username: account.username }
        }).then((response) => {
            setIsLoading(false)
            timesheets = response.data;
        }).catch((error) => {
            setIsLoading(false)
            console.log(error)
        })

        return timesheets
    }

    const getPeriodsDayTime = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/PeriodsDayTime`, {
                params: { username: account.username }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }
    const getAdditionalPeriods = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/AdditionalPeriods`, {
                params: { username: account.username }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const getAdditionalPeriodsWithTotals = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/AdditionalPeriodsWithTotals`, {
                params: { username: account.username }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const getLocation = async (emplID) => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/Location`, {
                params: {
                    username: account.username,
                    emplID: emplID
                }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const getStartDate = async (emplID) => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/startDate`, {
                params: {
                    username: account.username,
                    emplID: emplID
                }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const getEmployeeAdditionalInformation = async (emplID, compID) => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/employeeAdditionalInformation`, {
                params: {
                    username: account.username,
                    emplID: emplID,
                    compID: compID,
                }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }
    const getEmployeeList = async (periodTimesheet) => {
        setIsLoading(true)
        let resp = [];

        await axiosInstance.get(`${clientApi}api/teachersperiods/Employees`, {
            params: { username: account.username, company: periodTimesheet.company, branch: periodTimesheet.branch, location: periodTimesheet.location }
        }).then((response) => {
            let dropDownEmpl = []
            let emplList = []
            response.data.map((itr) => {
                let item = { label: itr.name, value: itr.employeeId }
                dropDownEmpl.push(item);
                emplList.push(itr)
            })
            resp = { dropDownEmpl, emplList }
        }).catch((error) => {
            console.log(error)
        })
        setIsLoading(false)
        return resp
    }

    const getApproversList = async () => {
        setIsLoading(true)
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/getapprovers`, {
                params: { username: account.username }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];
        }
    }

    const getPeriodsSubject = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/teachersperiods/PeriodsSubject`, {
                params: { username: account.username }
            });
            setIsLoading(false)
            return response.data;
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            return [];//should be empty
        }
    }

    const saveTeacherperiods = async (teacherPeriods) => {
        setIsLoading(true);
        let periods = []
        let ret = false;
        const keys = Object.keys(teacherPeriods);
        keys.forEach(key => {
            const nestedObject = teacherPeriods[key];
            periods.push(nestedObject)
        });
        var data = {
            username: account.username,
            teacherPeriodModels: periods,
        }
        await axiosInstance.post(`${clientApi}api/teachersperiods/save`, data, {
            params: { emplID: account.employeeId },
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        })
            .then(response => {
                setIsLoading(false)
                if (response.status == 200)
                    ret = true;
            })
            .catch(error => {
                setIsLoading(false)
                console.error('There was an error!', error);
                throw new Error(error)
            });
        return ret;
    }

    const saveTimesheets = async (teacherTimeSheets) => {
        setIsLoading(true);
        let sheets = [];
        let ret = false;
        const keys = Object.keys(teacherTimeSheets);
        keys.forEach(key => {
            const nestedObject = teacherTimeSheets[key];
            sheets.push(nestedObject)
        });

        await axiosInstance.put(`${clientApi}api/teachersperiods/savetimesheets`, sheets, {
            params: { emplID: account.employeeId, username: account.username }
        })
            .then(response => {
                setIsLoading(false)
                if (response.status == 200)
                    ret = true;
            })
            .catch(error => {
                setIsLoading(false)
                console.error('There was an error!', error);
                throw new Error(error)
            });
        return ret;
    }

    const submitTimesheet = async (teacherTimeSheetUI) => {
        setIsLoading(true);
        await axiosInstance.put(`${clientApi}api/teachersperiods/Submit`, teacherTimeSheetUI, {
            params: { emplID: account.employeeId, username: account.username, timesheetUI: teacherTimeSheetUI }
        })
            .then(response => {
                setIsLoading(false)
                return response.status;
            })
            .catch(error => {
                setIsLoading(false)
                console.error('There was an error!', error);
                throw new Error(error)
            });
    }

    const approveTimesheet = async (teacherTimeSheetUI) => {
        setIsLoading(true);
        await axiosInstance.put(`${clientApi}api/teachersperiods/Approved`, teacherTimeSheetUI, {
            params: { emplID: account.employeeId, username: account.username, timesheetUI: teacherTimeSheetUI }
        })
            .then(response => {
                setIsLoading(false)
                console.log(response.status)
                return response.status;
            })
            .catch(error => {
                setIsLoading(false)
                console.error('There was an error!', error);
                throw new Error(error)
            });
    }


    const deleteTimesheets = async (timeSheetIds) => {
        setIsLoading(true)
        let ret;
        await axiosInstance.delete(`${clientApi}api/teachersperiods/deleteTimesheet`, {
            params: { username: account.username, },
            data: timeSheetIds
        })
            .then((response) => {
                if (response.status === 200)
                    ret = true;
                else
                    ret = false;
            })
            .catch((error) => {
                console.log(error)
                ret = false;
            });
        setIsLoading(false)
        return ret;
    }

    return {
        saveTeacherperiods, saveTimesheets, getPeriodsSubject, getEmployeeList, getStartDate, getLocation,
        loadTeacherperiods, getPeriodsDayTime, getTimeSheets, getApproversList, deleteTimesheets, submitTimesheet, approveTimesheet, getEmployeeAdditionalInformation, getAdditionalPeriods, getAdditionalPeriodsWithTotals, isLoading
    }
}

